







































import { Component, Prop, Emit, Vue } from "vue-property-decorator";
import { ScannedMedicine } from "@/components/patient/medicine/types";

@Component
export default class QRCodeConfirmDialog extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: () => [] }) items!: ScannedMedicine[];

  private get isOpen(): boolean {
    return this.value;
  }

  private set isOpen(v: boolean) {
    this.input(v);
  }

  @Emit("input")
  private input(v: boolean): boolean {
    return v;
  }

  @Emit("save")
  private save(): void {
    return;
  }

  private close() {
    this.isOpen = false;
  }
}
